//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 20.01.2016.
 */

(function () {

    'use strict';

    angular.module('container.components')
        .directive('srsngDashboard', srsngDashboard);

    function srsngDashboard() {

        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'container/ui/app/components/dashboard/dashboard.html',
            controller: controller
        }

        
        function controller($scope, DASHBOARDINFO, MAINTENANCE_ENABLED, MAINTENANCE_INFO_MSG) {  
            
            $scope.maintenanceEnabled = MAINTENANCE_ENABLED === 'true' ? true : false;
            $scope.maintenanceMessage = (!MAINTENANCE_INFO_MSG || MAINTENANCE_INFO_MSG.includes('<MAINTENANCE_INFO_MESSAGE>') || MAINTENANCE_INFO_MSG.trim() === '') 
                ? "System maintenance is currently in progress. Some services might be unavailable." 
                : MAINTENANCE_INFO_MSG;
            $scope.displayDefaultInformation = displayDefaultInformation;
            $scope.displayEAInformation = displayEAInformation;
            $scope.displayBlankInformation = displayBlankInformation;
            $scope.displayMaintenanceInfo = displayMaintenanceInfo;
            
           
    
            function displayDefaultInformation() {
                return DASHBOARDINFO === 'DEFAULT';
            }
    
            function displayEAInformation() {
                return DASHBOARDINFO === 'EA';
            }
    
            function displayBlankInformation() {
                return DASHBOARDINFO === 'BLANK';
            }    
            
           function displayMaintenanceInfo() {
                 return $scope.maintenanceEnabled;
            }
        }

    }
})();